/**
 * The branch feature's explanations — hints, ⓘ texts and labels. Blocked-action
 * reasons are in `reasons.ts` (held to «[why]. [what to do].»); these describe
 * rather than block, so they live apart and are free of that shape.
 */

/** The switcher's hint (multi-branch design §7). */
export const SWITCHER_HINT = 'نمایش اطلاعات این شعبه در تقویم، جلسات، صندوق، انبار و گزارش‌ها';

export const ALL_BRANCHES_LABEL = 'همهٔ شعبه‌ها';
export const PRIMARY_TAG = 'اصلی';
export const PRIMARY_BRANCH_TAG = 'شعبهٔ اصلی';
export const ARCHIVED_BRANCH_TAG = 'بایگانی‌شده';

/** The staff drawer's ⓘ beside «شعبه‌های محل کار». */
export const STAFF_BRANCHES_INFO =
  'کارکنانی که دسترسی «همهٔ شعبه‌ها» رو ندارن فقط تقویم، جلسات، صندوق، هزینه‌ها و انبار همین شعبه‌ها رو می‌بینن. پرونده بیمار در همهٔ شعبه‌ها یکی است.';

/** The branch form's ⓘ on public visibility. */
export const BRANCH_VISIBILITY_INFO =
  'برای نمایش صفحهٔ شعبه در نتایج جست‌وجو، نشانی، شهر و تلفن رو وارد کنید. همچنین باید حداقل یک پزشک یا ساعت کاری ثبت شده باشه.';

/** On the primary, the two switches are the clinic's own, shown read-only. */
export const PRIMARY_SWITCHES_INFO = 'برای شعبهٔ اصلی از تنظیمات صفحهٔ عمومی کلینیک تغییر می‌کنه.';

/** The patient file is one file across branches (owner round 5). */
export const PATIENT_FILE_ACROSS_BRANCHES =
  'پرونده بیمار در همهٔ شعبه‌ها یکی است؛ سابقهٔ درمان هر شعبه با نام همون شعبه نمایش داده می‌شه.';

/** Hint on a branch chip (an event or a timeline row in «همهٔ شعبه‌ها»). */
export function branchChipHint(name: string): string {
  return `در ${name} ثبت شده.`;
}

/**
 * The locked add card's title (a plan without the `branches` feature). The
 * plan is named from data (the lock's required plan), never typed here.
 */
export function addBranchLockedTitle(planName: string | null): string {
  return planName ? `افزودن شعبه در پلن ${planName} است` : 'افزودن شعبه در پلن فعلی نیست';
}
